import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DropDown,HolidaypolicyDetailsesServiceProxy,CreateOrEditHolidaypolicyDetailsDto,CreateOrEditHoldiayPolicyDto, DropdownServicesServiceProxy, EmployeesServiceProxy, HoldiayPolicyDto, UserServiceProxy, CreateOrEditHolidayMapPolicyDto, HoldiayPoliciesServiceProxy, BranchDropDown, CreateOrEditHolidayMapPolicyDtoNew, DropDownEmployee, AlreadyAssignedDto } from '@shared/service-proxies/service-proxies';
import { LazyLoadEvent } from 'primeng/api';
import { Paginator } from 'primeng/paginator';
import { Table } from 'primeng/table';
import { finalize } from 'rxjs/operators';
import {MultiSelectModule} from 'primeng/multiselect';
import { ModalDirective } from 'ngx-bootstrap';
import { result } from 'lodash';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';



@Component({
  selector: 'app-holiday-calender',
  templateUrl: './holiday-calender.component.html',
  styleUrls: ['./holiday-calender.component.css']
})
export class HolidayCalenderComponent extends AppComponentBase implements OnInit {

  @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
  holidaypolicyDetails: CreateOrEditHolidaypolicyDetailsDto = new CreateOrEditHolidaypolicyDetailsDto();
  ardAssignedData:AlreadyAssignedDto[];


  constructor(
    injector: Injector,
    private _holidaypolicyDetailsesServiceProxy: HolidaypolicyDetailsesServiceProxy,
    private _holdiayPoliciesServiceProxy: HoldiayPoliciesServiceProxy,
    private _employeesServiceProxy: EmployeesServiceProxy,
    private _dropdownServiceProxy:DropdownServicesServiceProxy,
    private _userServiceProxy: UserServiceProxy,
    private router:Router,
    private route:ActivatedRoute,
    private fb: FormBuilder
  ) {
    super(injector);
  }

  policies:DropDown[];
  location:BranchDropDown[];
  enableDrop: boolean=false;
  yes:any=0;
  checked:boolean=false;
  enableEmployee:boolean=false;
  Holiday:boolean;
  PolicyName:string;
  active = false;
  PolicyNameDisable:boolean;
  filterText = '';
  policiesname:any;
  value:any;
  selectedPermission = '';
  role = '';
  onlyLockedUsers = false;
  Applicable:number=2;
  Employee:number;
  pay:any;
  selectedEmp: string[] = [];
  selectedbranches:any[]=[];
  public optionsApplicableTo: any = [
    { label: 'Employee', value: 1 },
    { label: 'Branch', value: 2 },
  ];
  public DropdownDo:any=[
    {label: 'Select', value: undefined},
        { label: 'Yes', value: 1 },
        { label: 'No', value: 0},
  ];
  public BranchOptions: any = [
    { label: 'Branch', code: 1 },
    { label: 'SubBranch', code: 2 },
  ];

  @ViewChild('dataTable', { static: true }) dataTable: Table;
  @ViewChild('paginator', { static: true }) paginator: Paginator;
 employeeData:DropDownEmployee[];
 empvalue : any;
 items: DropDown[];
 item: string;
 policyid:number;
 recordData:any;
 saving = false;
 tooltipMap = {};
 HolidayMapPolicyDto :CreateOrEditHolidayMapPolicyDtoNew[];
 getPolicyData: CreateOrEditHolidayMapPolicyDto[];

  ngOnInit() {
    this.filterpolicies()
    this.filterlocation()
    this.getUser()
    this.Applicable=2;
    for(var j=0;j<this.location.length;j++)
          {

              this.location[j].selected=false;
          }
          this.pay = null;
          this.enableDrop=false;
  }


  show(id: number, Ploicy?: string,record:any=[]): void {    
    this.PolicyName = Ploicy;
    this.recordData=record;
    this.active = true;
    this.policyid = id;
    this.PolicyNameDisable = true;
    this.policyAlrdAssigned();
    // Create a new array for the selected branches for this policy
    this.selectedbranches = [...(this.selectedbranches[this.policyid] || [])];
  
    this._holdiayPoliciesServiceProxy.getAllPolicyData(this.policyid,"holiday").subscribe(result => {
      this.getPolicyData = result;
      //console.log"Length of getPolicyData:", this.getPolicyData.length);
      if (this.getPolicyData.length != 0) {
        // Map branchIds to an array for quicker lookup
        const existingBranchIds = this.getPolicyData.map(policy => policy.branchId);
  
        // Shiwani
        this.location.forEach(branch => {
          const isSelected = existingBranchIds.includes(branch.value);
          branch.selected = isSelected;
          if (isSelected) {
            this.selectedbranches.push({ value: branch.value });
          }
        });
  
        this.pay = 1;
        this.enableDrop = true;
      } else {
        this.location.forEach(branch => (branch.selected = false));
        this.pay = null;
        this.enableDrop = false;
      }
  
      this.modal.show();
    });
  }
  
  
  filterpolicies()
  {
      this._dropdownServiceProxy.getPolicies().subscribe(Customer=>{
        this.policies=Customer;
  })
}

filterlocation()
{
    this._holdiayPoliciesServiceProxy.getLocation().subscribe(Customer=>{
      this.location=Customer;
})
}
DropbranchValidation(){
  if(this.pay==1)
  {
    this.enableDrop=true;
  }
  
  else {
  this.enableDrop=false;
  }
}
// branchValidation(event){
//   
//   if(this.Applicable==1){
//     this.enableDrop=false;
//     this.yes=true;
//     this.enableEmployee=true;
//   }
//   else if(this.Applicable==2){
//     this.enableDrop=true;
//     this.yes=true;
//     this.enableEmployee=false;
//   }
// }
getUser() {
  
   this._dropdownServiceProxy.getEmployees(false).subscribe(result => {
     this.employeeData=result;
      // this.items = [];
      //   for (let i = 0; i < 10000; i++) {
      //       this.items.push({label: 'Item ' + i value: 'Item ' + i});
      //   }
  });
}
onCheckboxChange(event: any) {
  
  const selectedEmployeeId = parseInt(event.target.value, 10);
  const isChecked = event.target.checked;

  if (isChecked) {
    this.selectedbranches.push({ value: selectedEmployeeId });
  } else {
    const index = this.selectedbranches.findIndex(item => item.value === selectedEmployeeId);

    if (index !== -1) {
      this.selectedbranches.splice(index, 1);
    }

    //console.log"length", this.selectedbranches.length);
    //console.log"selected branches", this.selectedbranches);
  }
}


policyAlrdAssigned()
{
  this._holdiayPoliciesServiceProxy.isAlreadyAssigned("Holiday").subscribe((result) => {
    this.ardAssignedData=result;
    });
}

isAssigned(branchId: number, policyId: number): void {
  this.ardAssignedData.forEach(item => {
    if (branchId === item.branchId) {
      const shouldAssign = policyId !== item.policyId;
      this.location.forEach(row => {
        if (branchId === row.value) {
          row.isAlreadyAssigned = !row.selected && shouldAssign;
          if (item.policyId !== policyId) {
            this.recordData.forEach(x => {
              if (x.holdiayPolicy.id === item.policyId) {
                this.tooltipMap[row.value] = `The ${x.holdiayPolicy.name} Policy already assigned.`; 
              }
            });
          } else {
            this.tooltipMap[row.value] = '';
          }
        }
        if (row.selected) {
          row.isAlreadyAssigned = false;
          this.tooltipMap[row.value] = "";
        }
      });
    }
  });
  if (!this.ardAssignedData.some(item => item.branchId === branchId)) {
    this.location.forEach(row => {
      if (branchId === row.value && policyId) {
        row.isAlreadyAssigned = false;
        this.tooltipMap[row.value] = "";
      }
    });
  }
}


Save(): void {
  // if (this.enableDrop && this.selectedbranches.length === 0) {
  //   this.notify.error('Please select at least one branch.');
  //   return;
  // }
  if (!this.enableDrop) {
    this.selectedbranches = [];
  }

  this.saving = true;
  let mapdto = new Array<CreateOrEditHolidayMapPolicyDtoNew>();

  //console.log"length", this.selectedbranches.length);
  //console.log"length", this.selectedbranches);
  this.saving = true;

  // Create a new copy of the selected branches array
  const selectedBranchesCopy = [...this.selectedbranches];

  for (var i = 0; i < selectedBranchesCopy.length; i++) {
    var mpdtop = new CreateOrEditHolidayMapPolicyDtoNew()
    mpdtop.branchID = selectedBranchesCopy[i].value;
    mpdtop.policyId = this.policyid;
    mpdtop.policyType = "Holiday";
    mpdtop.departmentId = 0;
    mpdtop.divisionId = 0;
    mapdto.push(mpdtop);
  }

  this._holdiayPoliciesServiceProxy.insertMapPolicy(this.policyid,mapdto)
    .pipe(finalize(() => {
      this.saving = false;
      this.selectedbranches = []; // Shiwani
    }))
    .subscribe(() => {
      this.notify.info(this.l('SavedSuccessfully'));
      this.close();
      this.selectedbranches = [];
      this.reloadPage();
    });
}

reloadPage(): void {
  this.paginator.changePage(this.paginator.getPage());
}

close(): void {
  
  
  
  this.selectedbranches = this.selectedbranches.filter(branch => branch.policyId !== this.policyid);

  // Shiwani
  this.location.forEach(branch => {
    const isSelected = this.selectedbranches.some(selectedBranch => selectedBranch.value === branch.value);
    branch.selected = isSelected;
  });

  this.selectedbranches = [];
  this.active = false;
  this.modal.hide();
  this.reloadPage();
}





}
